import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import {LoadStore} from './stores';
import ApplicationRouter from './ApplicationRouter';
import Splash from './components/SplashScreen';

/**
 * App
 */
export default class App extends React.Component {
  static displayName = 'App';
  static propTypes = {
    children: PropTypes.any,
    splash: PropTypes.bool.isRequired,
  };
  static defaultProps = {};

  /**
   * @constructor
   * @param  {Object} props
   */
  constructor(props) {
    super(props);
    this.state = {appReady: false};
    _.bindAll(this, 'onLoadStoreChange');
  }

  /**
   * THe load store changes, update state
   * @param  {Object} loadStoreState
   */
  onLoadStoreChange(loadStoreState) {
    if (loadStoreState.appStarted !== this.state.appReady) {
      this.setState({appReady: !this.state.appReady});
    }
  }

  /**
   * @override
   */
  componentDidMount() {
    LoadStore.listen(this.onLoadStoreChange);
  }

  /**
   * @override
   */
  componentWillUnmount() {
    LoadStore.unlisten(this.onLoadStoreChange);
  }

  /**
   * @override
   */
  render() {
    if (this.props.splash) {
      return (
        <div className="App">
          <Splash />
          {this.state.appReady && <ApplicationRouter />}
        </div>
      );
    }
    if (this.state.appReady) {
      return (
        <div className="App">
          <ApplicationRouter />
        </div>
      );
    }
    return false;
  }
}
